import React, { useState, useEffect } from "react";
import { Container, Button, Dropdown, Spinner, Modal } from "react-bootstrap";
import "../../Styles/yellowcalfcss/Bills.css";
import { FaEdit, FaEye, FaSearch, FaTrashAlt } from "react-icons/fa";
import { simplePostCall } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';
import { toast, ToastContainer } from 'react-toastify';
import ConfirmModal from '../../components/ConfirmModal';
import { useNavigate } from 'react-router-dom';
import ScaleLoader from 'react-spinners/ScaleLoader';
import CustomPagination from '../../components/CustomPagination ';
import { formatNumber } from '../../utils/formatNumber';






// --- SVG Components ---
const Eye = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const Edit = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M12 20h9"></path>
    <path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4 12.5-12.5z"></path>
  </svg>
);

const Trash2 = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"></path>
    <path d="M10 11v6"></path>
    <path d="M14 11v6"></path>
    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"></path>
  </svg>
);

const Download = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

// --- Main Component ---
export default function BillList() {
  const [bills, setBills] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ billNumber: "", billDate: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [nextPage, setNextPage] = useState(false);
  const [selectedBillIds, setSelectedBillIds] = useState([]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [id, setId] = useState(null);
  
  const itemsPerPage = 9999;

  // Toggle single checkbox
const handleSelectBill = (billId) => {
  setSelectedBillIds((prev) =>
    prev.includes(billId)
      ? prev.filter((id) => id !== billId)
      : [...prev, billId]
  );
};

// Toggle select all (optional but matches UI image)
const handleSelectAll = (checked) => {
  if (checked) {
    setSelectedBillIds(bills.map((b) => b.bill_id));
  } else {
    setSelectedBillIds([]);
  }
};

  // Toggle select all (optional but matches UI image)

  const handleDeleteBill = async () => {
    setIsDeleting(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      id: Number(id),
    };

    try {
      const response = await simplePostCall(
        ApiConfig.billDelete,
        JSON.stringify(requestBody),
      );

      if (response?.result) {
        toast.success(response?.message || "Supplier deleted successfully");
        setShowDeleteModal(false);
        fetchBillsList();
      } else {
        toast.error(response?.message || "Failed to delete supplier");
      }
    } catch (error) {
      console.error("Delete supplier error:", error);
      toast.error("Network error occurred");
    } finally {
      setIsDeleting(false);
    }
  };

  // Fetch data on load
  useEffect(() => {
    fetchBillsList();
  }, [currentPage]);

  const fetchBillsList = async () => {
    setLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");
    const user_id = localStorage.getItem("user_id");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      user_id: Number(user_id),
      language: "en",
      limit : itemsPerPage,
      page : currentPage
    };

    try {
      const response = await simplePostCall(
        ApiConfig.billviewList,
        JSON.stringify(requestBody),
      );

      if (response?.result && response?.data) {
        // Data Normalization: Handle mixed types (numbers vs "$ string")
        const normalizedData = response.data.map((item, index) => ({
          id: `${item.bill_number}-${index}`, // Unique key for React
          billNumber: item.bill_number,
          bill_id: item.bill_id,
          supplier: item.supplier_name,
          billDate: item.bill_date,
          dueDate: item.bill_due_date,
          totalAmount: formatNumber(item.bill_total_amount),
          status: item.bill_status.replace("_", " "), // "partial_paid" -> "partial paid"
        }));
        setBills(normalizedData);
setNextPage(response?.next_page)
      }

    } catch (error) {
      console.error("Error fetching bills:", error);
    } finally {
      setLoading(false);
    }
  };

  // Filter Logic
  const filteredBills = bills.filter(
    (bill) =>
      (bill.billNumber || "")
        .toLowerCase()
        .includes(filters.billNumber.toLowerCase()) &&
      (bill.billDate || "").includes(filters.billDate),
  );

  // Pagination Calculations
  const totalItems = filteredBills.length;
  const totalPages2 = Math.ceil(totalItems / itemsPerPage);
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
  const paginatedBills = filteredBills.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const getPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages2; i++) pageNumbers.push(i);
    return pageNumbers;
  };
  const handleClear = () => {
    setFilters({ billDate: "", billNumber: "" });
    // setMessage("Filters cleared!");
  };

  const handlePayBill = () => {
    if (selectedBillIds?.length < 1) {
      toast.error("Please select a bill");
      return;
    }

    navigate("/accountant/paybill", {
      state: {
        billIds: selectedBillIds,
      },
    });
  };
  return (
    <div className="bill-list-wrapper">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Header */}
      <div className="special-header panel-white-all">
        <h4 className="page-title">Purchase Bills</h4>
        <div className="action-buttons-group">
          <Button className="btn btn-primary" onClick={() => navigate("/accountant/CreateBill")}>
            Create Bill
          </Button>
          <Button className="btn btn-primary" onClick={() => navigate("/accountant/PaidBills")}>
            Paid Bill
          </Button>
          <Button className="btn btn-primary" onClick={() => navigate("/accountant/Suppliers")}>
            Suppliers
          </Button>
          <Dropdown show={dropdownOpen} onToggle={setDropdownOpen}>
            <Dropdown.Toggle className="btn btn-primary">
              <Download /> Export
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
              <Dropdown.Item href="#">Export to CSV</Dropdown.Item>
              <Dropdown.Item href="#">Export to PDF</Dropdown.Item>
              <Dropdown.Item href="#">Export to Excel</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="yc-list-body">
        {/* Filters */}
        <div className="yc-list-filter">
          <div className="ff-search-wrap">
            <FaSearch className="ff-search-icon" />
            <input
              type="text"
              className="form-control ff-search-input"
              placeholder="Bill Number"
              value={filters.billNumber}
              onChange={(e) => {
                setFilters({ ...filters, billNumber: e.target.value });
                setCurrentPage(1);
              }}
            />
          </div>

          <input
            type="date"
            className="form-control"
            value={filters.billDate}
            onChange={(e) => {
              setFilters({ ...filters, billDate: e.target.value });
              setCurrentPage(1);
            }}
          />

          <Button onClick={handleClear} className="btn btn-primary">
            Clear
          </Button>
        </div>

        {/* Column Header */}
        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-8">
            <div className="yc-list-cell bills-col-sr">
              <input
                type="checkbox"
                checked={bills?.length > 0 && selectedBillIds?.length === bills.length}
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
              <span>Sr No</span>
            </div>
            <div className="yc-list-cell">Bill Number</div>
            <div className="yc-list-cell">Supplier</div>
            <div className="yc-list-cell">Bill Date</div>
            <div className="yc-list-cell">Due Date</div>
            <div className="yc-list-cell">Total Amount</div>
            <div className="yc-list-cell">Status</div>
            <div className="yc-list-cell">Actions</div>
          </div>
        </div>

        {/* Rows */}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : filteredBills.length === 0 ? (
          <div className="yc-empty-state">No bills found.</div>
        ) : (
          <div className="yc-list-row-list">
            {filteredBills.map((b, index) => (
              <div key={b.id} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-8">
                  <div className="yc-list-cell bills-col-sr">
                    <input
                      type="checkbox"
                      checked={selectedBillIds?.includes(b.bill_id)}
                      onChange={() => handleSelectBill(b.bill_id)}
                    />
                    <span>{startItem + index}</span>
                  </div>
                  <div className="yc-list-cell">{b.billNumber}</div>
                  <div className="yc-list-cell">{b.supplier}</div>
                  <div className="yc-list-cell">{b.billDate}</div>
                  <div className="yc-list-cell">{b.dueDate}</div>
                  <div className="yc-list-cell">{b.totalAmount}</div>
                  <div className="yc-list-cell bills-col-status">{b.status}</div>
                  <div className="yc-list-cell yc-list-cell-actions">
                    <button
                      className="yc-action-icon"
                      onClick={() => navigate(`/accountant/ViewBill/${b.bill_id}`)}
                      title="View"
                    >
                      <FaEye />
                    </button>
                    <button
                      className="yc-action-icon"
                      onClick={() => navigate(`/accountant/createbill/${b.bill_id}`)}
                      title="Edit"
                    >
                      <FaEdit />
                    </button>
                    <button
                      className="yc-action-icon yc-action-icon--danger"
                      onClick={() => {
                        setId(b.bill_id);
                        setShowDeleteModal(true);
                      }}
                      title="Delete"
                    >
                      <FaTrashAlt />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="d-flex justify-content-end mt-3">
          <Button className="btn btn-primary" onClick={handlePayBill}>Pay Bill</Button>
        </div>
      </div>

      <ConfirmModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        title="Delete Bill"
        message="Are you sure you want to delete this bill?"
        confirmText="Delete"
        confirmVariant="danger"
        onConfirm={handleDeleteBill}
        isLoading={isDeleting}
      />
    </div>
  );
}
